module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_TALCO_VERTICALE.9454b548.png";